define([
	"dojo/_base/declare",
	"csi",
	"underscore",
	"./Increments"
], function(declare,csi,_,Increments) {

	return declare(Increments, {
		bRenderComparisonValues: false,

		headingToHtml: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode) {
			// summary: if size not in size chart, then show empty cell - otherwise render absolute value
			if (ctx.keyValue < 0) {
				refNode.innerHTML = csi.EMPTY_CHAR;
			} else {
				// see if we are on a 1-D dimension on a 2-D size chart
				const scDimension = ctx.getNode();
				const scRev = ctx.cache.getNode(scDimension.__Parent__);
				if (!_.isEmpty(scRev.SizeChartDimension2Sizes)) {
					const apparelDimension = ctx.cache.getNode(scDimension.Actual);
					if (apparelDimension && !_.contains(apparelDimension.DimensionDependencies, scRev.Dimension2Type)) {
						const keyDim1Size = ctx.cache.getNode(scRev.Sizes[ctx.keyValue]).Dimension1Size;
						const dim1KeyValue = scRev.SizeChartDimension1Sizes.indexOf(keyDim1Size);
						ctx.keyValue = dim1KeyValue;
					}
				}
				this.inherited(arguments);
			}
		},

		isIncrementDisplay: function(/*Context*/ctx) {
			// summary: return if currently displaying increment values
			return false;
		},

		isRelativeDisplay: function(/*Context*/ctx) {
			// summary: return if currently displaying relative increment values
			return false;
		},

		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: set index for Sample.ProductSize in SizeChart.SizeRange
			ctx.keyValue = ctx.view._nSizeIndex;
			this.inherited(arguments);
		},

		_canEditVectorNumber: function(/*Context*/ctx, /*Heading*/h) {
			// summary: make read-only
			return false;
		},

		_getFormattedValue: function(/*Context*/ctx, /*Heading*/h, /*Number?*/v, /*Function*/func) {
			// summary: if blanks and not the base size, then output base size value in parens
			var	v = this.inherited(arguments);
			if (v == null) {
				var	ranges = ctx.view.getSubSizeRangeData();
				var	key = ctx.keyValue;

				ctx.keyValue = ranges.getBaseIndex(key);
				v = "(" + this.inherited(arguments) + ")";
				ctx.keyValue = key;
			}

			return v;
		}
	});
});